import { BoxTool } from './BoxTool'
import { Vector } from './Vector';

export class ArrowTool extends BoxTool {
	constructor() {
		super({
			mode: 'arrow',
			name: '箭头工具',
			className: 'arrow',
		});
	}

	onRenderCanvas(ctx, drawing) {
		const { param, brushColor, brushWidth } = drawing;
		const [x, y, w, h, x1, x2, y1, y2] = param;
		const p1 = new Vector(x1, y1);
		const p2 = new Vector(x2, y2);
		const arrow = Vector.from(p1, p2);
		const p3 = p2.add(arrow.rotate(30).reverse().normalize(10));
		const p4 = p2.add(arrow.rotate(-30).reverse().normalize(10));

		ctx.save();
		ctx.strokeStyle = brushColor;
		ctx.lineWidth = brushWidth;
		ctx.lineCap = 'round';
		ctx.lineJoin = 'round';
		ctx.beginPath();
		ctx.moveTo(...p1);
		ctx.lineTo(...p2);
		ctx.moveTo(...p3);
		ctx.lineTo(...p2);
		ctx.lineTo(...p4);
		ctx.stroke();
		ctx.restore();
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/ArrowTool.js